import { useSelector } from 'react-redux';
import { useMedia } from 'react-use';
import { Problem } from '@yandex-int/k-common';
import { ProblemCoding } from '../../components/coding-problem/types';
import { checkProblemIsPythonCodingProblem } from '../problem/checkProblemIsPythonCodingProblem';
import { MEDIA_QUERY_DESKTOP_XS } from '../von-dyck-media-queries';
import { getIsStudent } from '../../components/user/selectors';

export const useMobileCodeEditorAvailability = (problem?: null | Problem | ProblemCoding) => {
    const isMobile = useMedia(MEDIA_QUERY_DESKTOP_XS);

    const isStudent = useSelector(getIsStudent);

    if (!problem || !isStudent) {
        return false;
    }

    const problemIsCodingProblem = checkProblemIsPythonCodingProblem(problem);
    const mobileCodeEditorIsAvailable = Boolean(problemIsCodingProblem && isMobile);

    return mobileCodeEditorIsAvailable;
};
